import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

// Tajuk halaman + breadcrumb
export default function PageHeader({ title, breadcrumbs = [], actions, subtitle }) {
  return (
    <div className="mb-4 sm:mb-6">
      <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mb-2" data-testid="breadcrumb">
        {breadcrumbs.map((b, i) => (
          <span key={i} className="flex items-center gap-1.5">
            {b.to ? (
              <Link to={b.to} className="hover:text-brand transition-colors">{b.label}</Link>
            ) : (
              <span className="text-foreground font-medium">{b.label}</span>
            )}
            {i < breadcrumbs.length - 1 && <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" />}
          </span>
        ))}
      </nav>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h1 className="text-xl sm:text-3xl font-bold tracking-tight text-foreground" data-testid="page-title">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
